<template>
    <div class="adminUserList">
        <Breadcumb :title="$t('alerts')" :breadcumb-data="breadcumbData">
        </Breadcumb>
                <b-tabs class="nav-tabs-top nav-responsive-xl cardcontainer">
                    <b-tab :title="$t('company_without_survey')" active>
                        <b-card no-body class="mb-3">
                            <b-card-body>
                                <b-form inline class="" @submit="searchSurvey">
                                    <datepicker style="min-width:250px" class="mr-sm-2  mb-sm-0" v-model="date_begin" :bootstrapStyling="true" :placeholder="$t('survey_begin_date')"/>
                                    <datepicker style="min-width:250px" class="mr-sm-2  mb-sm-0" v-model="date_end" :bootstrapStyling="true" :placeholder="$t('survey_end_date')"/>
                                    <b-btn type="submit" variant="primary">{{ $t('search')}}</b-btn>
                                </b-form>
                            </b-card-body>
                        </b-card>
                        <b-card>
                            <b-card-body>
                                <b-table
                                        :items="companiesWithoutSurvey"
                                        :fields="fields"
                                        :striped="true"
                                        :bordered="true"
                                        class="card-table">
                                    <template :slot="$t('branch')" slot-scope="data">
                                       <span>{{ data.item|findFather("BRANCH") }}</span>
                                    </template>
                                    <template :slot="$t('direction')" slot-scope="data">
                                        <span>{{ data.item|findFather('DIREC')}}</span>
                                    </template>
                                    <template :slot="$t('affiliation')" slot-scope="data">
                                        <span>{{ data.item|findFather('AFFECT')}}</span>
                                    </template>
                                    <template :slot="$t('company')" slot-scope="data">
                                        <span>{{ data.item|findFather('COMPAN')}}</span>
                                    </template>
                                    <template :slot="$t('subcompany')" slot-scope="data">
                                        <span>{{ data.item|findFather('SUBCOM')}}</span>
                                    </template>
                                    
                                    
                                </b-table>
                            </b-card-body>
                        </b-card>
                    </b-tab>
                    <b-tab :title="$t('company_without_drh')">
                        <b-card>
                            <b-card-body>
                                <b-table
                                        :items="companiesWithoutDrh"
                                        :fields="fields"
                                        :striped="true"
                                        :bordered="true"
                                        class="card-table">
    
                                    <template :slot="$t('branch')" slot-scope="data">
                                        <span>{{ data.item|findFather("BRANCH") }}</span>
                                    </template>
                                    <template :slot="$t('direction')" slot-scope="data">
                                        <span>{{ data.item|findFather('DIREC')}}</span>
                                    </template>
                                    <template :slot="$t('affiliation')" slot-scope="data">
                                        <span>{{ data.item|findFather('AFFECT')}}</span>
                                    </template>
                                    <template :slot="$t('company')" slot-scope="data">
                                        <span>{{ data.item|findFather('COMPAN')}}</span>
                                    </template>
                                    <template :slot="$t('subcompany')" slot-scope="data">
                                        <span>{{ data.item|findFather('SUBCOM')}}</span>
                                    </template>
                                </b-table>
                            </b-card-body>
                        </b-card>
                    </b-tab>
                </b-tabs>
    </div>
</template>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<style src="@/vendor/libs/vuejs-datepicker/vuejs-datepicker.scss" lang="scss"></style>
<script>
    import {GET_SURVEY_REQUEST, GET_SURVEYS_REQUEST, SURVEY_ADD_TARGETS_REQUEST} from '../../_store/survey/actiontypes'
    import Breadcumb from '../../components/breadcumb'
    import Datepicker from 'vuejs-datepicker'
    import moment from 'moment'
    import XLSX from 'xlsx';
    import slugify from 'slugify'
    import {SweetModal, SweetModalTab} from 'sweet-modal-vue'
    import {
        GET_COMPANIES_WITHOUT_MANAGER_REQUEST,
        GET_COMPANIES_WITHOUT_SURVEY_REQUEST
    } from "../../_store/company/actiontypes";
    
    export default {
        name: 'adminUserList',
        mounted() {
            this.breadcumbData = [
                { text: this.$t('welcome'), href: '/dashboard/' },
                { text: this.$t('alerts'), active: true },
            ];
            this.fields = [
                {
                    key: this.$t('branch'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('direction'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('affiliation'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('company'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('subcompany'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
            ],
            this.$store.dispatch(GET_COMPANIES_WITHOUT_SURVEY_REQUEST)
                .then(response => {
                    this.companiesWithoutSurvey = response.data.companies
                });
            this.$store.dispatch(GET_COMPANIES_WITHOUT_MANAGER_REQUEST, {target: "keolis_drh"})
                .then(response => {
                    this.companiesWithoutDrh = response.data.companies
                });
        },
        components: { Breadcumb, Datepicker},
        data() {
            return {
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Alertes', active: true },
                ],
                fields: [],
                companiesWithoutSurvey: [],
                companiesWithoutDrh: [],
                companiesWithoutRrh: [],
                companiesMorethanSurvey: [],
                date_end: '',
                date_begin: ''
            };
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            searchSurveyMorethanOne: function (e){
                e.preventDefault();
                let date_begin = ''
                let date_end = '';
                if (this.date_begin !== '')
                    date_begin = moment(this.date_begin).format('YYYY-MM-DD');
                if (this.date_end !== '')
                    date_end = moment(this.date_end).format('YYYY-MM-DD');
                this.$store.dispatch(GET_COMPANIES_WITHOUT_SURVEY_REQUEST, {
                    "morethanone": true,
                    "date_begin": date_begin,
                    "date_end": date_end,
                })
                    .then(response => {
                        this.companiesMorethanSurvey = response.data.companies
                    })

            },
            searchSurvey: function (e) {
                e.preventDefault();
                let date_begin = ''
                let date_end = '';
                if (this.date_begin !== '')
                    date_begin = moment(this.date_begin).format('YYYY-MM-DD');
                if (this.date_end !== '')
                    date_end = moment(this.date_end).format('YYYY-MM-DD');
                this.$store.dispatch(GET_COMPANIES_WITHOUT_SURVEY_REQUEST, {
                    "date_begin": date_begin,
                    "date_end": date_end,
                })
                    .then(response => {
                        this.companiesWithoutSurvey = response.data.companies
                    })

            },
        }
    };
</script>
